import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OrderStatusEnum } from '../globals-enums/order.status.enum';
import { POItemUnitEnum } from '../globals-enums/po.unit.enum';
import { PurchaseOrderService } from '../globals-services/purchase-order.service';
import { ConfirmClosePoDialogComponent } from './confirm-close-po-dialog/confirm-close-po-dialog.component';
import { ShowPartialDeliveriesComponent } from './show-partial-deliveries/show-partial-deliveries.component';
import { UpdatePoItemDeliveryDialogComponent } from './update-po-item-delivery-dialog/update-po-item-delivery-dialog.component';

export interface UsersData {
  name: string;
  id: number;
}

const ELEMENT_DATA: UsersData[] = [
  { id: 1560608769632, name: 'Artificial Intelligence' },
  { id: 1560608796014, name: 'Machine Learning' },
  { id: 1560608787815, name: 'Robotic Process Automation' },
  { id: 1560608805101, name: 'Blockchain' }
];
@Component({
  selector: 'app-purchase-order',
  templateUrl: './purchase-order.component.html',
  styleUrls: ['./purchase-order.component.css']
})
export class PurchaseOrderComponent implements OnInit {
  addPurchaseOrder: boolean = false;
  OrderStatusEnum = OrderStatusEnum;
  orderForm: FormGroup;
  poList: any;
  isUpdate: boolean = false;
  selectedManufacturer: any;
  unitList = [
    { id: 1, name: "Kg" },
    { id: 2, name: "Tonnes" },
    { id: 3, name: "Liters" },
  ]

  formulaList: any;
  manufacturerList: any;
  closeOrders: any;
  closeOrdersPoList: any;
  showAddButton: boolean = false;
  isEditDelivery: boolean = false;
  partialDeliveries: any = [];

  showSuccessChange: boolean = false;
  //showDeletSuccess: boolean = false;

  // displayedColumns: string[] = ['name', 'quantity', 'receivedQuantity', 'unit', 'batchNumber', 'manufactureDate', 'expiryDate', 'status','action'];
  displayedColumns: string[] = ['name', 'quantity', 'unit', 'status', 'action'];
  displayedAddToInvColumns: string[] = ['name', 'receivedQuantity', 'batchNumber', 'date'];
  dataSource: any = [];
  deliveries: any = []
  poId: any;
  @ViewChild(MatTable) table: MatTable<any>;

  totalCount: any;
  page: number = 0
  pageSize: number = 10;
  poStatus: boolean = false;
  openDeliveryList: any;
  pOUnitEnum = POItemUnitEnum
  constructor(
    private translateService: TranslateService,
    private purchaseOrderService: PurchaseOrderService,
    private router: Router,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {

    this.showAddButton = true;
    this.getPOsCountByStatus()
  }

  getOpenPOs() {
    let data = {
      page: this.page,
      pageSize: this.pageSize
    }

    this.purchaseOrderService.getAllOpenPos(data).subscribe(
      (response: any) => {


        this.poList = response;
        this.openDeliveryList = response;

        this.poList.forEach(po => {
          po.partialCompleted = [];
          po.newCompleted = [];
          po.partialCount = null;

          if (po.poItems != null) {
            po.poItems.forEach(poItem => {
              if (poItem.status == OrderStatusEnum.PARTIALLY_COMPLETED) {

                po.partialCompleted.push(poItem)

                po.partialCount = po.partialCompleted.length;

              }

              if ((poItem.status == OrderStatusEnum.NEW) || (poItem.status == OrderStatusEnum.COMPLETED)) {
                po.newCompleted.push(poItem);

              }

            });
          }


        });

      },
      (error: HttpErrorResponse) => {

      }
    )

  }
  getPOsCountByStatus() {

    let data = {
      delivered: this.poStatus
    }
    this.purchaseOrderService.getPOCountByStatus(data).subscribe(
      (response: any) => {


        this.totalCount = response;

        if (this.totalCount > 0) {
          this.getOpenPOs()
        }

      },
      (error: HttpErrorResponse) => {

      }
    )

  }
  getClosedPOCount() {

    let data = {
      delivered: this.poStatus
    }
    this.purchaseOrderService.getPOCountByStatus(data).subscribe(
      (response: any) => {


        this.totalCount = response;

        if (this.totalCount > 0) {
          this.getClosedPOs()
        }

      },
      (error: HttpErrorResponse) => {

      }
    )

  }

  onEditPo(po) {

    this.router.navigateByUrl("/purchase-order/update/" + po.id);

  }
  ViewDetailPo(id) {
    this.router.navigateByUrl("/purchase-order/view/" + id);
  }


  // deletePo(po) {
  //   this.purchaseOrderService.deletePurchaseOrder(po).subscribe(
  //     (response: any) => {
  //       this.showDeletSuccess = true
  //     },
  //     (error: HttpErrorResponse) => {

  //     }
  //   )

  // }

  getClosedPOs() {
    let data = {
      page: this.page,
      pageSize: this.pageSize
    }
    this.purchaseOrderService.getClosedOrders(data).subscribe(
      (response: any) => {
        this.closeOrders = response;
        this.closeOrdersPoList = response;
      },
      (error: HttpErrorResponse) => {

      }
    )

  }
  onTabChanged(event) {

    let index = event.index;

    switch (index) {
      // case 0:
      //   this.poStatus = false
      //   this.getPOsCountByStatus();
      //   this.showAddButton = true;
      //   break;
      case 0:
        this.poStatus = false
        this.getPOsCountByStatus();
        this.showAddButton = true;
        break;
      case 1:
        this.poStatus = true
        this.getClosedPOCount();
        this.showAddButton = true;
        break;
    }
  }




  editDelivery(po) {
    this.isEditDelivery = true;
    this.partialDeliveries = []
    po.poItems.forEach(item => {
      if (item.status == OrderStatusEnum.PARTIALLY_COMPLETED) {
        this.partialDeliveries.push(item)

      }

    });
  }
  backToPo() {
    this.isEditDelivery = false
  }
  showPartialDeliveries(item) {



    const dialogRef = this.dialog.open(ShowPartialDeliveriesComponent, {
      width: '50%',
      height: '50%',
      data: {
        item,
        title: "Partial Deliveries"
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {

      }

    });
  }



  searchPOFromList(searchText) {

    this.openDeliveryList = this.poList.filter(res => {

      return res.poNumber.toLowerCase().match(searchText.toLocaleLowerCase());

    }
    );

  }

  searchPOFromCloseOrderList(searchText) {

    this.closeOrders = this.closeOrdersPoList.filter(res => {

      return res.poNumber.toLowerCase().match(searchText.toLocaleLowerCase());

    }
    );
  }

  paginatorEvent(event) {

    this.page = event.pageIndex;
    this.pageSize = event.pageSize;

    this.getOpenPOs();
  }
  closeOrderPaginatorEvent(event) {

    this.page = event.pageIndex;
    this.pageSize = event.pageSize;

    this.getClosedPOs();
  }
}
